import { Sparkles } from "lucide-react";

import { Card, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";

interface AICreativeRec {
  title: string;
  description: string;
}

export function AICreativeRecommendations({ items, blurred }: { items: AICreativeRec[]; blurred?: boolean }) {
  return (
    <Card className={cn(blurred && "blur-[1px] select-none pointer-events-none border border-[#DDD6FE]/30 bg-gradient-to-br from-[#F5F3FF] via-[#EFF6FF] to-white p-6")}>
      <div className="flex items-center gap-2">
        <div className="rounded-md bg-violet-100 p-2">
          <Sparkles className="size-5 text-violet-600" strokeWidth={2.5} />
        </div>
        <p className="text-base font-semibold text-foreground">AI Creative Recommendations</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {items.map((item) => (
          <Card key={item.title}>
            <CardContent className="p-4 space-y-1.5">
              <p className="text-sm font-semibold text-foreground">{item.title}</p>
              <p className="text-xs text-muted-foreground">{item.description}</p>
            </CardContent>
          </Card>
        ))}
      </div>
    </Card>
  );
}
